module.exports = __webpack_public_path__ + "static/media/geneva-digital-trophy_mid.8e281333.jpg";